import { render } from "./AllManufacturerModels.vue?vue&type=template&id=239d23d9"
import script from "./AllManufacturerModels.vue?vue&type=script&lang=js"
export * from "./AllManufacturerModels.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__